/**
 * frontend/src/pages/CategoryPage.js
 * Subcategory list. Route: /browse/:catId
 */
import { useParams, useNavigate } from 'react-router-dom';
import { getCategoryById } from '../data/taxonomy';
import styles from './CategoryPage.module.css';

export default function CategoryPage() {
  const { catId } = useParams();
  const navigate  = useNavigate();
  const category  = getCategoryById(catId);

  if (!category) {
    return (
      <div className={styles.page}>
        <button className={styles.backBtn} onClick={() => navigate('/browse')}>← Browse</button>
        <p className={styles.notFound}>Category not found.</p>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.hero} style={{ '--cat-color': category.color, '--cat-color-light': category.colorLight }}>
        <button className={styles.backBtn} onClick={() => navigate('/browse')}>← Back</button>
        <div className={styles.heroText}>
          <h1 className={styles.heroDevanagari}>{category.label}</h1>
          <p className={styles.heroIast}>{category.labelIast}</p>
          <p className={styles.heroDesc}>{category.description}</p>
        </div>
      </div>

      <div className={styles.section}>
        <p className={styles.sectionLabel}>TEXTS IN THIS COLLECTION</p>
        <div className={styles.subList}>
          {category.subcategories.map((sub) => (
            <button
              key={sub.id}
              className={`${styles.subCard} ${!sub.available ? styles.subCardDimmed : ''}`}
              onClick={() => sub.available && navigate(`/browse/${catId}/${sub.id}`)}
            >
              <div className={styles.subCardInner}>
                <div className={styles.subText}>
                  <span className={styles.subDevanagari}>{sub.label}</span>
                  <span className={styles.subIast}>{sub.labelIast}</span>
                  {sub.description && <span className={styles.subDesc}>{sub.description}</span>}
                </div>
                <div className={styles.subFooter}>
                  <div className={styles.badges}>
                    {sub.available
                      ? <span className={styles.badgeAvailable}>Available</span>
                      : <span className={styles.badgeComingSoon}>Coming soon</span>
                    }
                    {sub.shankara && <span className={styles.badgeShankara}>Śaṅkara Bhāṣya</span>}
                  </div>
                  {sub.available && <span className={styles.arrow} style={{ color: category.colorLight }}>→</span>}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
